import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

import {
  SET_GAME_COUPON_POPUP_SHOW_STATUS,
  UPDATE_GAME_ENABLE_COUPON_LIST,
  UPDATE_GAME_DISABLE_COUPON_LIST,
  UPDATE_GAME_EXPIRE_COUPON_LIST,
  LOAD_GAME_COUPON_LIST,
  UPDATE_GAME_ACTIVE_COUPON_ID,
  LOAD_PAYTYPE_COUPON_LIST,
  UPDATE_PAYTYPE_ACTIVE_COUPON_ID,
  SET_PAYTYPE_COUPON_POPUP_SHOW_STATUS,
  SET_VIP_COUPON_SHOW_STATUS,
  SET_BIRTH_COUPON_SHOW_STATUS,
  LOAD_VIP_COUPON_INFO
} from '@store/officialWebStore/coupon';
import { popupType, showPopup } from '@plugins/biPoint/_configWebstoreV2';
export default {
  data() {
    return {
      isShowCouponConfirmPopup: false,
      hasConfirmCoupon: false
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      isShowGameCouponEntry: state => state.coupon.isShowGameCouponEntry,
      isShowGameCouponPopup: state => state.coupon.isShowGameCouponPopup,
      isShowGameItemUseBtn: state => state.coupon.isShowGameItemUseBtn,
      gameCouponEnableList: state => state.coupon.gameCouponEnableList,
      gameCouponDisableList: state => state.coupon.gameCouponDisableList,
      gameCouponExpireList: state => state.coupon.gameCouponExpireList,
      gameActiveCouponId: state => state.coupon.gameActiveCouponId,
      isShowVipCouponPopup: state => state.coupon.isShowVipCouponPopup,
      isShowBirthCouponPopup: state => state.coupon.isShowBirthCouponPopup,
      vipLevel: state => state.coupon.vipLevel,
      vipNextLevelPoint: state => state.coupon.vipNextLevelPoint,
      vipSumPoint: state => state.coupon.vipSumPoint,
      vipCouponList: state => state.coupon.vipCouponList,
      birthCouponList: state => state.coupon.birthCouponList,

      isShowPaytypePopupCoupon: state => state.coupon.isShowPaytypePopupCoupon,
      paytypeEnableCouponList: state => state.coupon.paytypeEnableCouponList,
      paytypeDisableCouponList: state => state.coupon.paytypeDisableCouponList,
      paytypeExpireCouponList: state => state.coupon.paytypeExpireCouponList,
      paytypeActiveCouponId: state => state.coupon.paytypeActiveCouponId
    }),
    ...mapGetters([
      'activeGameCouponProductList',
      'activePaytypeCouponInfo',
      'activePaytypeCouponFullReductType',
      'activePaytypeCouponDiscountType',
      'activePaytypeCouponReductPrice',
      'activePaytypeCouponReductionName',
      'activePaytypeCouponDiscountName'
    ]),
    submitCouponInfoName() {
      if (!this.paytypeActiveCouponId) {
        return '';
      }

      if (this.activePaytypeCouponFullReductType) {
        return this.activePaytypeCouponReductionName;
      }

      return this.activePaytypeCouponDiscountName;
    }
  },
  watch: {
    activePaytypeCouponInfo() {
      this.hasConfirmCoupon = false;
    }
  },
  methods: {
    ...mapMutations({
      setGameCouponPopupShowStatus: SET_GAME_COUPON_POPUP_SHOW_STATUS,
      updateGameEnableCouponList: UPDATE_GAME_ENABLE_COUPON_LIST,
      updateGameDisableCouponList: UPDATE_GAME_DISABLE_COUPON_LIST,
      updateGameExpireCouponList: UPDATE_GAME_EXPIRE_COUPON_LIST,
      updateGameActiveCouponId: UPDATE_GAME_ACTIVE_COUPON_ID,
      setPaytypeCouponPopupShowStatus: SET_PAYTYPE_COUPON_POPUP_SHOW_STATUS,
      updatePaytypeActiveCouponId: UPDATE_PAYTYPE_ACTIVE_COUPON_ID,
      setVipCouponShowStatus: SET_VIP_COUPON_SHOW_STATUS,
      setBirthCouponShowStatus: SET_BIRTH_COUPON_SHOW_STATUS
    }),
    ...mapActions({
      loadGameCouponList: LOAD_GAME_COUPON_LIST,
      loadPaytypeCouponList: LOAD_PAYTYPE_COUPON_LIST,
      loadVipCouponInfo: LOAD_VIP_COUPON_INFO
    }),
    hideGameCouponPopup() {
      this.setGameCouponPopupShowStatus(false);
    },
    showGameCouponPopup() {
      this.setGameCouponPopupShowStatus(true);
      showPopup(popupType.gameCouponPopup);
    },
    hideVipCouponPopup() {
      this.setVipCouponShowStatus(false);
    },
    hideBirthCouponPopup() {
      this.setBirthCouponShowStatus(false);
    },
    resetGameActiveCoupon() {
      this.updateGameActiveCouponId('');
    },
    checkInGameActiveCoupon(productId, cpProductId) {
      let length = this.activeGameCouponProductList.length;
      for (let i = 0; i < length; i++) {
        if (
          productId == this.activeGameCouponProductList[i].PRODUCT_ID &&
          cpProductId == this.activeGameCouponProductList[i].CP_PRODUCT_ID
        ) {
          return true;
        }
      }
      return false;
    },
    hidePaytypeCouponPopup() {
      this.setPaytypeCouponPopupShowStatus(false);
    },
    showPaytypeCouponPopup() {
      this.setPaytypeCouponPopupShowStatus(true);
      showPopup(popupType.paytypeCouponPopup);
    },
    showVipCouponPopup() {
      this.setVipCouponShowStatus(true);
      showPopup(popupType.vipCouponPopup);
    },
    resetPaytypeActiveCoupon() {
      this.updatePaytypeActiveCouponId('');
    },
    changePaytypeCouponList(param) {
      this.resetPaytypeActiveCoupon();
      this.loadPaytypeCouponList(param);
    },
    refreshGameCoupon() {
      this.loadGameCouponList();
      this.showGameCouponPopup();
    }
  }
};
